import React, { useRef, useEffect } from "react";
import "../../style.css";

const UnderConstruction = () => {
  const headingRef = useRef(null);

  const animateText = () => {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let iteration = 0;
    let interval = setInterval(() => {
      if (headingRef.current) {
        headingRef.current.innerText = headingRef.current.innerText
          .split("")
          .map((letter, index) => {
            if (index < iteration) {
              return headingRef.current.dataset.value[index];
            }
            return letters[Math.floor(Math.random() * 26)];
          })
          .join("");

        if (iteration >= headingRef.current.dataset.value.length) {
          clearInterval(interval);
        }

        iteration += 1 / 3;
      }
    }, 30);
  };

  useEffect(() => {
    animateText(); // Trigger immediately on mount
    setTimeout(animateText, 3000); // Then after 3 seconds

    const triggerRandomAnimation = () => {
      const randomDelay = Math.random() * (7000 - 3000) + 3000; // Random time between 3 and 7 seconds
      setTimeout(() => {
        animateText();
        triggerRandomAnimation(); // Schedule next animation
      }, randomDelay);
    };

    triggerRandomAnimation();

    // No cleanup function needed as the component unmounting will naturally stop the timeouts
  }, []);

  return (
    <div className="under-construction-container">
      <div className="under-construction">
        <h1 ref={headingRef} data-value="UNDER CONSTRUCTION">
          UNDER CONSTRUCTION
        </h1>
        <div className="underline"></div>
        <p>
          <ion-icon name="chevron-back-outline"></ion-icon>
          Try other entries meanwhile
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </p>
      </div>
    </div>
  );
};

export default UnderConstruction;
